var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    { attrs: { effect: "dark", placement: "top" } },
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _vm._v(_vm._s(_vm.tooltipContent))
      ]),
      _c(
        "el-popover",
        {
          attrs: { placement: "top", width: "360" },
          model: {
            value: _vm.showRelease,
            callback: function($$v) {
              _vm.showRelease = $$v
            },
            expression: "showRelease"
          }
        },
        [
          _c("p", [_vm._v(_vm._s(_vm.popoverContent))]),
          _c(
            "div",
            { staticStyle: { "text-align": "right", margin: "0" } },
            [
              _c("el-input", {
                attrs: { placeholder: "Σχόλιο Αποδέσμευσης", type: "textarea" },
                model: {
                  value: _vm.releaseComment,
                  callback: function($$v) {
                    _vm.releaseComment = $$v
                  },
                  expression: "releaseComment"
                }
              }),
              _c(
                "p",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "text" },
                      on: {
                        click: function($event) {
                          _vm.showRelease = false
                        }
                      }
                    },
                    [_vm._v("Άκυρο")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        disabled: _vm.enableRelease
                      },
                      on: { click: _vm.releaseApplication }
                    },
                    [_vm._v("Αποστολή")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "release-button",
              attrs: {
                slot: "reference",
                size: "mini",
                type: "warning",
                disabled: !_vm.releaseChecked
              },
              on: {
                click: function($event) {
                  _vm.showRelease = true
                }
              },
              slot: "reference"
            },
            [_vm._v("Αποδέσμευση σε " + _vm._s(_vm.relOrRer))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e1b7d3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e1b7d3e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/releaseButton.vue
// module id = null
// module chunks = 